module.exports = __webpack_public_path__ + "img/sloth-suitcase.00fa0b4.png";